import { useMutation } from "@tanstack/react-query";

import { viewMatch, ViewMatchRequest } from "@/api";


const useViewMatch = () => {
  return useMutation({
    mutationFn: (body: ViewMatchRequest) => {
      return viewMatch(body);
    },
  });
};

export { useViewMatch };
